import styled from "styled-components";

export const ErrorMessage = styled.div`
  color: ${({ theme }) => theme.red};
  font-size: 12px;
`;
